import { defineComponent, Ref, ref } from "vue";
import { FilterBaseProps } from "./base.jsx";

export const Months = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Aout",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
];

export const Days = [ "Lu", "Ma", "Me", "Je", "Ve", "Sa", "Di" ];

export const FilterDatePicker = defineComponent({

    props: {
        currentDate: {
            type        : Object as () => Date,
            required    : true,
        },

        refSelectedDate: {
            type        : Object as () => Ref<Date>,
            required    : true,
        },
    },

    setup(props) {
        const refDatePreview = ref<Date>(props.refSelectedDate.value);

        function renderDays() {
            const refDate       = props.refSelectedDate;
            const currentDate   = props.currentDate;
            const days          = [];
            const date          = new Date(refDatePreview.value);
            const currentMonth  = date.getMonth();
            const nextMonth     = (currentMonth + 1) % 12;

            date.setDate(1);
            date.setDate(-(date.getDay() - 1));

            function selectDate(date: Date) {
                refDate.value = date;
            }

            while (true) {
                date.setDate(date.getDate() + 1);

                if ((date.getMonth() === nextMonth) && (date.getDay() === 1))
                    break;

                const cachedDate = new Date(date);

                const isCurrentDate = (cachedDate.getDate() === currentDate.getDate())
                    && (cachedDate.getMonth() === currentDate.getMonth())
                    && (cachedDate.getFullYear() === currentDate.getFullYear())

                const isCurrentSelected = (cachedDate.getMonth() === refDate.value.getMonth())
                    && (cachedDate.getDate() === refDate.value.getDate())
                    && (cachedDate.getFullYear() === refDate.value.getFullYear());

                days.push(
                    <div class={{
                        "date-days-day"     : true,
                        "date-other-month"  : (cachedDate.getMonth() !== currentMonth),
                        "date-current"      : isCurrentDate,
                        "date-selected"     : isCurrentSelected,
                    }} onClick={() => selectDate(cachedDate)}>
                        <div class="date-number">
                            {cachedDate.getDate()}
                        </div>
                    </div>
                );
            }

            return days;
        }

        function nextMonth(offset: number) {
            const date = new Date(refDatePreview.value);

            date.setMonth(date.getMonth() + offset);

            refDatePreview.value = date;
        }

        function changeHours(e: Event) {
            const value = (e.target as HTMLInputElement).value;
            const hours = Number(value || 0);

            props.refSelectedDate.value.setHours(hours);
            refDatePreview.value.setHours(hours);

            // Force update component.
            props.refSelectedDate.value = new Date(props.refSelectedDate.value);
        }

        function changeMinutes(e: Event) {
            const value     = (e.target as HTMLInputElement).value;
            const minutes   = Number(value || 0);

            props.refSelectedDate.value.setMinutes(minutes);
            refDatePreview.value.setMinutes(minutes);

            // Force update component.
            props.refSelectedDate.value = new Date(props.refSelectedDate.value);
        }

        return () => {
            const date = props.refSelectedDate.value;

            return (
                <div class="date-picker">
                    <div class="date-header">
                        <div class="date-prev-month material-symbols-outlined" onClick={() => nextMonth(-1)}>
                            arrow_back_ios
                        </div>

                        <div class="date-selected-month">
                            {Months[date.getMonth()]}
                        </div>

                        <div class="date-selected-year">
                            {date.getFullYear()}
                        </div>

                        <div class="date-next-month material-symbols-outlined" onClick={() => nextMonth(1)}>
                            arrow_forward_ios
                        </div>
                    </div>

                    <div class="date-days-names">
                        {Days.map((day) => (
                            <div class="date-days-name">
                                {day}
                            </div>
                        ))}
                    </div>

                    <div class="date-days-list">
                        {renderDays()}
                    </div>

                    <div class="date-time">
                        <input type="text" class="date-hours" placeholder="0" value={date.getHours().toString().padStart(2, "0")} onChange={(e) => changeHours(e)} />
                        :
                        <input type="text" class="date-minutes" placeholder="00" value={date.getMinutes().toString().padStart(2, "0")} onChange={(e) => changeMinutes(e)} />
                    </div>
                </div>
            );
        };
    },
});

export const FilterDate = defineComponent({
    props: FilterBaseProps,

    setup(props) {
        const currentDate = new Date();

        // Clear seconds and milliseconds.
        currentDate.setSeconds(0, 0);

        const refDateAfter  = ref<Date>(props.values[0] || new Date(currentDate.getTime() - (2 * 24 * 60 * 60 * 1000)));
        const refDateBefore = ref<Date>(props.values[1] || new Date(currentDate));

        return () => (
            <>
                <div class="date-pickers">
                    <FilterDatePicker
                        currentDate={currentDate}
                        refSelectedDate={refDateAfter} />

                    <FilterDatePicker
                        currentDate={currentDate}
                        refSelectedDate={refDateBefore} />
                </div>

                <div class="date-submit" onClick={() => props.onselect([ refDateAfter.value, refDateBefore.value ])}>
                    <span class="material-symbols-outlined">save</span>
                    Enregistrer la date
                </div>
            </>
        );
    },
});
